var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16763 4.87812C6.16763 5.33516 6.16763 5.77813 6.31177 6.19297C4.79653 7.97188 0.423096 13.0309 0.423096 13.0309L0.525049 14.307C0.525049 14.307 1.74849 15.4672 1.9313 15.2914C2.4727 14.7641 2.80317 14.4055 2.80317 14.4055L3.0577 12.8814L4.71392 12.7595L4.84681 11.1141L6.59161 11.0807L6.60884 9.31977L8.46122 9.39359L8.77763 8.73125C9.32255 8.9668 9.81825 9.06172 10.4546 9.06172C12.8628 9.06172 14.814 7.18438 14.814 4.87109C14.814 2.55781 12.8614 0.6875 10.4532 0.6875C8.04497 0.6875 6.16763 2.56484 6.16763 4.87812ZM12.8034 4.0625C12.8034 4.33263 12.7233 4.5967 12.5732 4.82131C12.4231 5.04592 12.2098 5.22098 11.9602 5.32435C11.7107 5.42773 11.436 5.45478 11.1711 5.40208C10.9061 5.34938 10.6628 5.21929 10.4718 5.02828C10.2808 4.83727 10.1507 4.5939 10.098 4.32896C10.0453 4.06401 10.0723 3.78939 10.1757 3.53982C10.2791 3.29025 10.4541 3.07694 10.6787 2.92686C10.9033 2.77678 11.1674 2.69668 11.4375 2.69668C11.617 2.69649 11.7947 2.7317 11.9604 2.80027C12.1262 2.86884 12.2769 2.96944 12.4037 3.09631C12.5306 3.22317 12.6312 3.37381 12.6998 3.5396C12.7684 3.7054 12.8036 3.88309 12.8034 4.0625Z",
    fill: "#62718A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkey);
export default __webpack_public_path__ + "static/media/vkey.b2448c2a7538b8f2d5efac708aba8880.svg";
export { ForwardRef as ReactComponent };